/* eslint-disable arrow-body-style */
import _ from 'lodash';
import moment from 'moment';
import Nzh from 'nzh';
import { getCnyText } from '@/utils/helpers';
import {
    serviceTypeList,
    serviceType9AList,
    serviceType9BList,
    nationalityList,
    serviceFeePlannedPayWay,
} from '../../assets/commonData/options';

function getIncomeType(value) {
    return _.find(serviceTypeList, ['value', value])?.label;
}

function getServiceType(value) {
    return _.find([...serviceType9AList, ...serviceType9BList], ['key', value])
        ?.label;
}

function getNationalityTxt(value) {
    return _.find(nationalityList, ['key', value])?.label;
}

function getServiceFeePlannedPayWayTxt(value) {
    return _.find(serviceFeePlannedPayWay, ['key', value])?.label;
}

export default (data, cmpName, title) => {
    const nzh = new Nzh({
        ch: '零壹貳參肆伍陸柒捌玖', // 數字
        ch_u: '個拾佰仟萬億', // 單位
        ch_f: '負', // 負字符
        ch_d: '點', // 小數點字符
        m_u: '元角分', // 金額單位
        m_t: getCnyText(data.cny), // 金額前綴
        m_z: '整', // 金額無小數後綴
    });

    function getRealPayAmtInOriginalCny() {
        const realPayAmtInOriginCny = (Math.round(data.amt * data.cnyRat) - data.taxAmt - data.gen2Amt)
            / data.cnyRat;
        return Math.round(realPayAmtInOriginCny * 100) / 100;
    }

    function getBsnLabelTxt() {
        if (data.personalOutsourcingSno === -1) return '身分證號碼';

        switch (data.idTyp) {
        case 0:
            return '身分證號碼';
        case 3:
            return '營業統一編號';
        case 1:
            return '護照號碼';
        case 2:
            return '居留證';
        default:
            return '---';
        }
    }

    function getPermanentAddrTxt() {
        if (data.personalOutsourcingSno === -1) return '';

        if (data.nationality === 0) {
            return `${data.permanentAdR_CODE || ''}${data.permanentAddrCty}${data.permanentAddr}`;
        }
        if (data.nationality === 1) {
            return `${data.permanentAddr} ${data.permanentAdR_CODE} ${data.permanentAddrAra}`;
        }
        return '---';
    }
    function getContactAddrTxt() {
        if (data.personalOutsourcingSno === -1) return '';

        if (data.nationality === 0) {
            return `${data.adR_CODE || ''}${data.contactAddrCty}${data.contactAddr}`;
        }
        if (data.nationality === 1) {
            return `${data.contactAddr} ${data.adR_CODE} ${data.contactAddrAra}`;
        }
        return '---';
    }

    function getBankNameAll() {
        if (data.accountType === 2) {
            return `${data.abroadBankName}`;
        }
        if (data.bankName && data.bnkBoo) {
            return `${data.bankName} (${data.bnkBoo})`;
        }
        if (data.bnkBoo) {
            return `(${data.bnkBoo})`;
        }
        return '';
    }

    return {
        cmpName, // 公司名稱
        title, // 標題
        systemNo: data.systemNo, // 來源系統單號
        creator: data.crt_nam, // 公司經辦人
        createDat: moment(data.crtDat).format('YYYY/MM/DD'), // 申請日期
        currDat: moment().format('YYYY/MM/DD'), // 印表日期
        projectNam: data.projectNam, // 所屬專案
        nam: data.nam, // 勞務摘要
        description: data.description, // 勞務內容
        payee: data.payee, // 領款人姓名
        nationalityNam: data.personalOutsourcingSno === -1 ? '' : getNationalityTxt(data.nationality) || '---', // 國籍
        idTypTxt: getBsnLabelTxt(), // 證件類型
        bsn: data.bsn, // 證件號碼
        permanentAddrAra: data.permanentAddrAra, // 戶籍地址-外國地區
        contactAddrAra: data.contactAddrAra, // 聯絡地址-外國地區
        permanentAddrCty: data.permanentAddrCty, // 戶籍地址-本國縣市
        contactAddrCty: data.contactAddrCty, // 聯絡地址-本國縣市
        permanentAddrTxt: getPermanentAddrTxt(), // 戶籍地址
        contactAddrTxt: getContactAddrTxt(), // 聯絡地址
        phone: data.phone, // 聯絡電話
        email: data.email, // E-mail
        incomeTypeNam: getIncomeType(data.incomeType) || '---', // 所得類別
        serviceTypeNam: getServiceType(data.serviceType) || '---', // 業別代號
        accountType: data.accountType, // 帳戶類型（2=外國）
        bankNameAll: data.plannedPayWay === 1 ? '' : getBankNameAll(), // 收款銀行
        bnkNam: data.plannedPayWay === 1 ? '' : data.bnkNam, // 收款戶名
        bnkAcc: data.plannedPayWay === 1 ? '' : data.bnkAcc, // 收款帳號
        plannedPayWayTxt:
            getServiceFeePlannedPayWayTxt(data.plannedPayWay) || '---', // 預計付款方式
        plannedPayDatTxt: moment(data.plannedPayDat).format('YYYY/MM/DD') || '---', // 預計付款日期
        // realPayWayTxt: getPaymentPayWayTxt(data.payWay) || '---', // 實際付款方式
        // realPayDatTxt: moment(data.pay_dat).format('YYYY/MM/DD') || '---', // 實際付款日期
        cny: data.cny, // 幣別
        cnyRat: data.cnyRat, // 約定匯率
        amt: data.amt.toLocaleString('en'), // 應付金額
        amtTw: Math.round(data.amt * data.cnyRat).toLocaleString('en'), // 應付金額(約當台幣)
        taxAmt: data.taxAmt.toLocaleString('en'), // 代扣所得稅
        gen2Amt: data.gen2Amt.toLocaleString('en'), // 代扣二代健保
        taxRatio: data.taxRatio, // 代扣所得稅率
        gen2Ratio: data.gen2Ratio, // 代扣二代健保費率
        realPayAmt: data.realPayAmt.toLocaleString('en'), // 實付金額（約當台幣）
        realPayAmtInOrignalCny: getRealPayAmtInOriginalCny(), // 實付金額（原幣別）
        idCardFront: data.idCardFront, // 身分證正面
        idCardBack: data.idCardBack, // 身分證反面
        amtChineseNumber: nzh.toMoney(data.amt), // 應付金額中文大寫
    };
};
